import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import bg from '../../assets/images/bg.svg';
import { PopUpBox } from '../../components';
import { saveSessionInfo } from '../../utils/common';
import QuickCashEntry from '../QuickCash20000/Entry';
import { saveQuickCashPendingAttribution } from '../QuickCash20000/storage';

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisiblePopUpSendOTP, setIsVisiblePopUpSendOTP] = useState(false);
  const [isVisiblePopUpBoxLoginBox, setIsVisiblePopUpLoginBox] = useState(false);
  const [isVisibleQuickCash, setIsVisibleQuickCash] = useState(false);

  const [detectCamera, setDetectCamera] = useState(true);


  useEffect(() => {
    if (!detectCamera) {
      navigate('/check-device-no-camera');
      return;
    }
    const params = new URLSearchParams(location.search);
    const open = params.get('open');

    setIsVisiblePopUpSendOTP(false);
    setIsVisiblePopUpLoginBox(false);
    setIsVisibleQuickCash(false);

    if (open === 'register') {
      setIsVisiblePopUpSendOTP(true);
      saveSessionInfo();
    } else if (open === 'check_status') {
      setIsVisiblePopUpLoginBox(true);
      saveSessionInfo();
    } else if (open === 'quick-cash-20000') {
      // 기존 신청 유지를 선택할 수 있으므로 Quick Cash 유입 정보는 OTP 성공 전까지
      // 대기 상태로만 저장하고 현재 register의 session_id를 덮어쓰지 않는다.
      saveQuickCashPendingAttribution(location.search);
      setIsVisibleQuickCash(true);
    } else {
      window.location.href = process.env.REACT_APP_HOME_URL;
    }
  }, [detectCamera, location, navigate])
  

  useEffect(() => {
    // detect camera
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      // Firefox 38+ seems having support of enumerateDevicesx
      navigator.enumerateDevices = function (callback) {
        navigator.mediaDevices.enumerateDevices().then(callback);
      };
    }

    let MediaDevices = [];
    let isHTTPs = window.location.protocol === 'https:';
    let canEnumerate = false;

    if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
      canEnumerate = true;
    } else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
      canEnumerate = true;
    }

    let hasMicrophone = false;
    let hasSpeakers = false;
    let hasWebcam = false;

    let isMicrophoneAlreadyCaptured = false;
    let isWebcamAlreadyCaptured = false;

    function checkDeviceSupport(callback) {
      if (!canEnumerate) {
        return;
      }

      if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
        navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
      }

      if (!navigator.enumerateDevices && navigator.enumerateDevices) {
        navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
      }

      if (!navigator.enumerateDevices) {
        if (callback) {
          callback();
        }
        return;
      }

      MediaDevices = [];
      navigator.enumerateDevices(function (devices) {
        devices.forEach(function (_device) {
          let device = {};
          for (let d in _device) {
            device[d] = _device[d];
          }

          if (device.kind === 'audio') {
            device.kind = 'audioinput';
          }

          if (device.kind === 'video') {
            device.kind = 'videoinput';
          }

          let skip;
          MediaDevices.forEach(function (d) {
            if (d.id === device.id && d.kind === device.kind) {
              skip = true;
            }
          });

          if (skip) {
            return;
          }

          if (!device.deviceId) {
            device.deviceId = device.id;
          }

          if (!device.id) {
            device.id = device.deviceId;
          }

          if (!device.label) {
            device.label = 'Please invoke getUserMedia once.';
            if (!isHTTPs) {
              device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
            }
          } else {
            if (device.kind === 'videoinput' && !isWebcamAlreadyCaptured) {
              isWebcamAlreadyCaptured = true;
            }

            if (device.kind === 'audioinput' && !isMicrophoneAlreadyCaptured) {
              isMicrophoneAlreadyCaptured = true;
            }
          }

          if (device.kind === 'audioinput') {
            hasMicrophone = true;
          }

          if (device.kind === 'audiooutput') {
            hasSpeakers = true;
          }

          if (device.kind === 'videoinput') {
            hasWebcam = true;
          }

          // there is no 'videoouput' in the spec.
          MediaDevices.push(device);

          return {
            hasWebcam,
            hasMicrophone,
            hasSpeakers,
            isMicrophoneAlreadyCaptured,
            isWebcamAlreadyCaptured,
          };
        });

        if (callback) {
          callback();
        }
      });
    }

    checkDeviceSupport(function () {
      setDetectCamera(hasWebcam);
    });
  }, []);

  return (
    <>
      <div className="flex flex-1 flex-col bg-white">
        <img src={bg} alt="" />
        <p className="text-center font-bold text-primary2 text-[28px] mt-5">
          特快網上私人貸款
        </p>
        <p className="text-primary2 text-center font-bold">Cashing Pro・WHY NOT？</p>
      </div>
      {isVisiblePopUpSendOTP && <PopUpBox.SendPhoneNumber />}
      {isVisiblePopUpBoxLoginBox && <PopUpBox.LoginBox />}
      {isVisibleQuickCash && <QuickCashEntry />}
    </>
  );
}

export default Home;
